module.exports = __webpack_public_path__ + "static/mti_logo-dc438007e9e29d245b28da66db67023c.jpg";